import React from 'react';
import { GriefHeartIcon } from './grief-heart-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_1 } from './topic-card-shared';

import griefPersonImage from './grief-person.webp';

interface GriefTopicCardProps {
  title: string;
  className?: string;
}

export const GriefTopicCard: React.FC<GriefTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute left-0 top-6 h-12 w-[55px] shrink-0 sm:-left-4 sm:top-8 sm:h-[72px] sm:w-[82px]">
          <GriefHeartIcon fill={TOPIC_CARD_ICON_1} className="h-full w-full" />
        </div>
        <img
          src={griefPersonImage}
          alt=""
          className="relative z-10 ml-10 aspect-[24/37] w-16 shrink-0 object-cover object-top sm:w-[96.002px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
